export default __webpack_public_path__ + "static/media/business_owned.b061d45c.pdf";